export default __webpack_public_path__ + "static/media/portfolio-177.56b88a95.jpg";